import { render, staticRenderFns } from "./imageBox.vue?vue&type=template&id=5c25869f&scoped=true&"
import script from "./imageBox.vue?vue&type=script&lang=js&"
export * from "./imageBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c25869f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c25869f')) {
      api.createRecord('5c25869f', component.options)
    } else {
      api.reload('5c25869f', component.options)
    }
    module.hot.accept("./imageBox.vue?vue&type=template&id=5c25869f&scoped=true&", function () {
      api.rerender('5c25869f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/imageBox.vue"
export default component.exports